import { jsx as _jsx } from "react/jsx-runtime";
import { ConsentScriptBoundary } from '@/components/consent/ConsentScriptBoundary';
import { FullScreenLoader } from '@/components/ui/full-screen-loader';
import { useAuth } from '@/hooks/use-auth';
import { Redirect } from 'wouter';
export function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    if (isLoading) {
        return _jsx(FullScreenLoader, {});
    }
    if (!isAuthenticated) {
        return _jsx(Redirect, { to: "/login" });
    }
    return _jsx(ConsentScriptBoundary, { children: children });
}
